import script from "./TextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEditor.vue?vue&type=script&setup=true&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=5bcb1450&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcb1450"]])

export default __exports__